export default {
  methods: {
    totalAmountCredited (transaction, lessPriceAdjustment = false) {
      if (!transaction.hasOwnProperty('associatedTransactions') || transaction.associatedTransactions.length < 1) {
        return 0
      }

      let totalCredited = transaction.associatedTransactions.reduce((runningTotal, transaction) => {
        if ((transaction.request_type === 'credit' || transaction.request_type === 'achcredit') && transaction.response_code === '000' && transaction.parent_transaction_id === transaction.id) {
          return runningTotal + transaction.total_amount
        }
        return runningTotal
      }, 0)

      return totalCredited
    },

    totalAmountSettled (transaction, lessPriceAdjustment = false) {
      let totalSettled = 0

      if (transaction.response_code === '000' && transaction.settled) {
        if (lessPriceAdjustment) {
          totalSettled += transaction.total_amount - transaction.fee_amount
        } else {
          totalSettled += transaction.total_amount
        }
      }

      if (!transaction.hasOwnProperty('associatedTransactions') || transaction.associatedTransactions.length < 1) {
        return totalSettled
      }

      let childrenTotalSettled = transaction.associatedTransactions.reduce((runningTotal, childTransaction) => {
        if ((childTransaction.request_type === 'sale' || childTransaction.request_type === 'ach') && childTransaction.response_code === '000' && childTransaction.settled && childTransaction.parent_transaction_id === transaction.id) {
          if (lessPriceAdjustment) {
            return runningTotal + childTransaction.total_amount - childTransaction.fee_amount
          } else {
            return runningTotal + childTransaction.total_amount
          }
        }
        return runningTotal
      }, 0)

      return totalSettled + childrenTotalSettled
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/associated.js